export default "__VITE_ASSET__BBSQeDdx__"